<section class="toast__title mat-body-small">
	@if (title()) {
			<span>{{ title() }}</span>
	} 
	@else if(localizedTitle()){
			<span>{{ localizedTitle()!.defaultText| translate : localizedTitle()!.token : localizedTitle()!.scope}}</span>
  }
</section>

@if (text()) {
			<span>{{ text() }}</span>
} 
@else if(localizedText()){
		<span>{{ localizedText()!.defaultText| translate : localizedText()!.token : localizedText()!.scope}}</span>
}
